const shouldUseStandardGetStats = require('./shouldUseStandardGetStats')();

// getRtcStatsReport is only supported on browsers that support the standard getStats API.
module.exports = shouldUseStandardGetStats;
